import React from 'react'
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Link,
  Stack,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography
} from '@mui/material'
import {
  ArrowBack,
  BarChart,
  Event,
  Forum,
  History,
  Language,
  Launch,
  SportsEsports,
  Storefront,
  Verified
} from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

const CodeBlock: React.FC<{ children: string }> = ({ children }) => {
  return (
    <Box
      component="pre"
      sx={{
        m: 0,
        p: 1.5,
        overflowX: 'auto',
        borderRadius: 2,
        backgroundColor: 'rgba(0,0,0,0.35)',
        border: '1px solid rgba(255,255,255,0.12)',
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
        fontSize: 14
      }}
    >
      {children}
    </Box>
  )
}

const ComoFuncionaPage: React.FC = () => {
  const navigate = useNavigate()

  return (
    <Box sx={{ py: { xs: 5, md: 8 } }}>
      <Container maxWidth="lg">
        <Grid container spacing={3.5} sx={{ alignItems: 'flex-start' }}>
          <Grid item xs={12} md={12}>
            <Stack spacing={2.5}>
              <Stack spacing={1}>
                <Typography variant="h3" sx={{ fontWeight: 900, lineHeight: 1.05 }}>
                  Como funciona
                </Typography>
                <Typography sx={{ color: 'text.secondary', maxWidth: 980 }}>
                  Siga o passo a passo para entrar no servidor, vincular sua conta no Discord e acessar o site com
                  estatísticas e histórico.
                </Typography>
              </Stack>

              <Card sx={{ border: '1px solid rgba(255,255,255,0.10)', backgroundColor: 'rgba(255,255,255,0.02)' }}>
                <CardContent sx={{ p: { xs: 2.5, md: 3 } }}>
                  <Stepper orientation="vertical" activeStep={-1} sx={{ '& .MuiStepContent-root': { ml: 3.4 } }}>
                    <Step expanded>
                      <StepLabel
                        icon={
                          <Box
                            sx={{
                              width: 34,
                              height: 34,
                              borderRadius: 2,
                              display: 'grid',
                              placeItems: 'center',
                              background:
                                'linear-gradient(135deg, rgba(0,230,118,0.22), rgba(0,217,255,0.18), rgba(255,109,0,0.14))',
                              border: '1px solid rgba(255,255,255,0.10)'
                            }}
                          >
                            <SportsEsports fontSize="small" />
                          </Box>
                        }
                      >
                        <Typography sx={{ fontWeight: 900 }}>1º passo — Acesso ao Servidor</Typography>
                      </StepLabel>
                      <StepContent>
                        <Stack spacing={1}>
                          <Typography sx={{ color: 'text.secondary' }}>
                            Acesse o servidor <strong>BR_Warzone_Palworld</strong>.
                          </Typography>
                          <Typography sx={{ color: 'text.secondary' }}>
                            Entre diretamente no jogo e conecte-se ao nosso servidor para começar sua aventura.
                          </Typography>
                        </Stack>
                      </StepContent>
                    </Step>

                    <Step expanded>
                      <StepLabel
                        icon={
                          <Box
                            sx={{
                              width: 34,
                              height: 34,
                              borderRadius: 2,
                              display: 'grid',
                              placeItems: 'center',
                              background:
                                'linear-gradient(135deg, rgba(0,230,118,0.22), rgba(0,217,255,0.18), rgba(255,109,0,0.14))',
                              border: '1px solid rgba(255,255,255,0.10)'
                            }}
                          >
                            <Forum fontSize="small" />
                          </Box>
                        }
                      >
                        <Typography sx={{ fontWeight: 900 }}>2º passo — Vincule sua conta no Discord</Typography>
                      </StepLabel>
                      <StepContent>
                        <Stack spacing={1.25}>
                          <Typography sx={{ color: 'text.secondary' }}>
                            Acesse <strong>#link-new-players</strong> e digite:
                          </Typography>
                          <CodeBlock>{'!link palworld seu@email.com'}</CodeBlock>

                          <Alert severity="warning">
                            IMPORTANTE: Digite seu e-mail <strong>corretamente</strong>. Ele será seu acesso ao site com
                            stats e histórico.
                          </Alert>

                          <Typography sx={{ color: 'text.secondary' }}>O bot enviará um código no seu privado.</Typography>

                          <Alert severity="info">
                            ATENÇÃO: o código expira em <strong>1 dia</strong>. Após isso, digite novamente{' '}
                            <strong>!link palworld seu@email.com</strong>.
                          </Alert>
                        </Stack>
                      </StepContent>
                    </Step>

                    <Step expanded>
                      <StepLabel
                        icon={
                          <Box
                            sx={{
                              width: 34,
                              height: 34,
                              borderRadius: 2,
                              display: 'grid',
                              placeItems: 'center',
                              background:
                                'linear-gradient(135deg, rgba(0,230,118,0.22), rgba(0,217,255,0.18), rgba(255,109,0,0.14))',
                              border: '1px solid rgba(255,255,255,0.10)'
                            }}
                          >
                            <Verified fontSize="small" />
                          </Box>
                        }
                      >
                        <Typography sx={{ fontWeight: 900 }}>3º passo — Confirme no jogo</Typography>
                      </StepLabel>
                      <StepContent>
                        <Stack spacing={1.25}>
                          <Typography sx={{ color: 'text.secondary' }}>
                            Digite <strong>link 0000</strong> (a palavra <strong>link</strong> seguida do código) no chat
                            do jogo:
                          </Typography>
                          <CodeBlock>{'link 0000'}</CodeBlock>
                          <Typography sx={{ color: 'text.secondary' }}>
                            O bot confirmará e enviará no seu privado o link para cadastro de sua senha no site do
                            servidor.
                          </Typography>
                        </Stack>
                      </StepContent>
                    </Step>

                    <Step expanded>
                      <StepLabel
                        icon={
                          <Box
                            sx={{
                              width: 34,
                              height: 34,
                              borderRadius: 2,
                              display: 'grid',
                              placeItems: 'center',
                              background:
                                'linear-gradient(135deg, rgba(0,230,118,0.22), rgba(0,217,255,0.18), rgba(255,109,0,0.14))',
                              border: '1px solid rgba(255,255,255,0.10)'
                            }}
                          >
                            <Language fontSize="small" />
                          </Box>
                        }
                      >
                        <Typography sx={{ fontWeight: 900 }}>4º passo — Acesse o site</Typography>
                      </StepLabel>
                      <StepContent>
                        <Stack spacing={1.25}>
                          <Typography sx={{ color: 'text.secondary' }}>
                            Acesse:{' '}
                            <Link
                              href="https://palworld.warzone-servers.com.br/"
                              target="_blank"
                              rel="noopener noreferrer"
                              underline="hover"
                            >
                              https://palworld.warzone-servers.com.br/
                            </Link>
                          </Typography>

                          <Typography sx={{ color: 'text.secondary' }}>Lá você encontra:</Typography>
                          <Stack spacing={1}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <BarChart fontSize="small" />
                              <Typography sx={{ color: 'text.secondary' }}>Estatísticas</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <Event fontSize="small" />
                              <Typography sx={{ color: 'text.secondary' }}>Eventos</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <History fontSize="small" />
                              <Typography sx={{ color: 'text.secondary' }}>Histórico</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <Storefront fontSize="small" />
                              <Typography sx={{ color: 'text.secondary' }}>Loja</Typography>
                            </Box>
                          </Stack>
                        </Stack>
                      </StepContent>
                    </Step>
                  </Stepper>
                </CardContent>
              </Card>

              <Card sx={{ border: '1px solid rgba(255,255,255,0.10)' }}>
                <CardContent sx={{ p: { xs: 2.5, md: 3 } }}>
                  <Stack spacing={1.25}>
                    <Typography variant="h4" sx={{ fontWeight: 900 }}>
                      Pronto para começar
                    </Typography>
                    <Typography sx={{ color: 'text.secondary' }}>
                      Após completar esses passos, você terá acesso completo ao nosso ecossistema e poderá aproveitar
                      tudo que o Warzone Servers oferece.
                    </Typography>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
                      <Button startIcon={<ArrowBack />} variant="outlined" onClick={() => navigate('/')}>
                        Voltar para a Home
                      </Button>
                      <Button
                        startIcon={<Launch />}
                        variant="contained"
                        color="info"
                        component="a"
                        href="https://palworld.warzone-servers.com.br/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Abrir o site
                      </Button>
                    </Stack>
                  </Stack>
                </CardContent>
              </Card>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default ComoFuncionaPage
